import { useInfiniteQuery, keepPreviousData } from "@tanstack/react-query"
import { api } from "@/app/api/client"
import type { FeedResponse, FeedAction } from "./types"

export interface FeedFilters {
  userId?: string
  action?: FeedAction
}

export function useRecentUpdates(filters: FeedFilters) {
  return useInfiniteQuery<FeedResponse>({
    queryKey: ["recent-updates", filters],
    initialPageParam: 1,
    placeholderData: keepPreviousData,
    queryFn: ({ pageParam }) => {
      const p = new URLSearchParams({ page: String(pageParam), per_page: "50" })
      if (filters.userId) p.set("user_id", filters.userId)
      if (filters.action) p.set("action", filters.action)
      return api.get<FeedResponse>(`/audit_logs?${p.toString()}`)
    },
    getNextPageParam: (last) =>
      last.meta.page < last.meta.total_pages ? last.meta.page + 1 : undefined,
  })
}
